import React, { useEffect, useState } from 'react';
import classname from 'classnames';

import { Spinner, Alert } from 'react-bootstrap';
import { telehealthService } from '../../../../_services/telehealth.service';

function ProviderNotes({ telehealth }) {
  const [editMode, setEditMode] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [providerNotes, setProviderNotes] = useState(telehealth.providerNotes || '');
  const [error, setError] = useState(false);

  useEffect(() => {
    setProviderNotes(telehealth.providerNotes)
  }, [telehealth])

  const buttonClasses = classname('btn btn-block mt-3', {
    'btn-success': editMode,
    'btn-primary': !editMode
  });

  return <>
    {error &&
      <Alert variant="danger" onClose={() => setError(false)} dismissible>
        Could not save at this time. Please try again.
      </Alert>
    }

    <textarea
      onChange={(e) => setProviderNotes(e.target.value)}
      value={providerNotes}
      disabled={editMode === false}
      className="form-control" rows="8"></textarea>

    {!isSaving &&
      <button
        onClick={() => {
          if (!editMode) {
            setEditMode(true)
          } else {
            setIsSaving(true);

            telehealthService.saveProviderNotes(telehealth, providerNotes)
              .then(() => {
                setIsSaving(false);
                setEditMode(false)
              })
              .catch(() => {
                setIsSaving(false);
                setError(true);
              });
          }
        }}
        className={buttonClasses}>{editMode ? 'Save' : 'Edit'}</button>
    }

    {isSaving &&
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    }
  </>
}

export default ProviderNotes;